import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { withGoogleMap, GoogleMap, Marker, InfoWindow, Polygon, OverlayView } from 'react-google-maps';
import MarkerClusterer from 'react-google-maps/lib/addons/MarkerClusterer';
import { Carousel, Button } from 'react-bootstrap';
import _ from 'lodash';

import MarkerCategoryModal from './markerCategoryModal.js';
import { parseExpectedPickUpTime } from '../../businessLogic/expectedPickUpTimeParser.js';
import formatCamelCase from '../../businessLogic/formatCamelCase.js';
import formatId from '../../businessLogic/formatId.js';
import getCurLang from '../../businessLogic/getCurLang.js';
import {
  markerIcons,
  buildMapMarkersList,
  showTeam
} from '../../businessLogic/mapMarkers.js';
import { darkTheme } from '../../constants/mapStyles.js';
import { gettext, getStatus } from '../../i18n/service.js';
import { arrayToDictionary } from '../../utils/array';
import './OrdersMap.scss';

const mapStatuses = arrayToDictionary(['new', 'assigned', 'onWayToDelivery', 'waitingForPickup', 'pickedUp' , 'partlyPickedUp']);
const getPixelPositionOffset = (width, height) => ({
  x: -(width / 2),
  y: -(height + 20),
});
const GettingStartedGoogleMap = withGoogleMap(props => (
  <GoogleMap
    ref={props.onMapMounted}
    defaultCenter={JSON.parse(localStorage.getItem('mapCenter'))?JSON.parse(localStorage.getItem('mapCenter')):{ lat: 0, lng: 0 }}
    defaultZoom={3}
    zoom={JSON.parse(localStorage.getItem('mapZoom'))?JSON.parse(localStorage.getItem('mapZoom')):3}
    onClick={()=>{props.onMapClick();props.clearSelectedOrders();}}
    onBoundsChanged={()=>props.setDefaultCenterAndZoom()}
    options={{ styles: darkTheme }}>
    {
      props.nearestDriversPosition
        ? props.nearestDriversPosition.map((position, index)=>{
          let path=[position];
          if(props.nearestCenter) {
            path=[position, props.nearestCenter];
          }
          return <Polygon path={path} key={index}/>;
        })
        : ''
    }

    {props.polygon ? <Polygon path={props.polygon} /> : ''}
    <Button
      className="showCategoryModal"
      onClick={()=>{props.toggleCategoryModal();props.updateUpCategoryIndex(false);}}
      style={{ bottom: props.fullSize ? 'calc(130px + 100% - 100vh)' : '80px'}}>
      <img src="./apIcon.png"/>
    </Button>
    <MarkerClusterer
      averageCenter
      enableRetinaIcons
      gridSize={60}
      defaultZoomOnClick={true}
    >
      {
        props.markers.map((marker, index) => {
          const stringifiedLocation = JSON.stringify(marker.position);
          const ref = `marker_${index}`;
          const popup = props.setOfLocationsToShowPopup.has(stringifiedLocation) ? props.renderInfoWindow(ref, marker) : null;
          return (
            <Marker
              position={marker.position}
              key={index}
              opacity={marker.opacity}
              defaultAnimation={4}
              icon={marker.icon}
              onClick={() => { props.onMarkerClick(stringifiedLocation); }}>
              {popup}
            </Marker>
          )
        })
      }
      {_.map(props.driversLocations, (d) => {
        if (!d.id) return null
        const driver = _.find(props.drivers, { id: d.driverId });
        if (!driver || driver.driverStatus !== 'active') {
          return null;
        }
        if((props.driverShowType=="fulltime")&&driver&&(driver.isFullTime!=true)){
          return;
        }

        if((props.driverShowType=="freelancer")&&driver&&(driver.isFullTime==true)){
          return;
        }
        const ref = `driver_${d.id}`;
        const position = d.gpsLocation
                          ?{ lat: d.gpsLocation.lat, lng: d.gpsLocation.lng }
                          :{ lat: d.lat, lng: d.lng };
        const popup = props.setOfDriverLocationIdsToShowPopup.has(d.id) ? props.renderDriverInfoWindow(ref, d) : null;
        if(position.lat)
          return (
            <Marker
              key={ref}
              position={position}
              icon={markerIcons.carIcon}
              onClick={() => props.onDriverMarkerClick(d.id, d.driverId)}>
              {popup}
            </Marker>
          );
      })}
    </MarkerClusterer>
    {
      props.nearestDrivers.map((nearestDriver) => {
        const overlayPostion = nearestDriver.driverGpsLocations.gpsLocation ? nearestDriver.driverGpsLocations.gpsLocation : nearestDriver.driverGpsLocations;
        return (

          <OverlayView
            key={nearestDriver.id}
            position={overlayPostion}
            mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
            getPixelPositionOffset={getPixelPositionOffset}
          >
          <div className="driver_distance">
            {' '+(nearestDriver.google.fullWay.distance/1000).toFixed(1)+ ' '+ gettext('KM')+', '+(nearestDriver.google.fullWay.duration/60).toFixed(0)+ ' '+gettext('MIN')+', '+ nearestDriver.orders.length.toString() + ' '+gettext('JOBS')}
          </div>

        </OverlayView>
        );
      })
    }
  </GoogleMap>
));


class OrdersMap extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      dashboardType: 'onDemand'
    };
    _.bindAll(this, ['changeMapStyle', 'handleMapMounted', 'setDefaultCenterAndZoom', 'renderDriverInfoWindow', 'renderInfoWindow']);
  }

  componentDidMount() {
    this.setState({ dashboardType: localStorage.getItem('dashboardType') });
  }
  handleMapMounted(map) {
    this._map = map;
    if(this.props.getOrdersMap)
      this.props.getOrdersMap(map);
  }

  setDefaultCenterAndZoom() {
    let location = this._map.getCenter();
    localStorage.setItem('mapCenter', JSON.stringify({lat:location.lat(),lng:location.lng()}));
    if(this._map.getZoom() > 3) {
      localStorage.setItem('mapZoom', this._map.getZoom());
    } else {
      localStorage.setItem('mapZoom', 3);
    }

    this.setState({})
  }

  shouldComponentUpdate(nextProps) {
    const props = this.props;
    return props.users !== nextProps.users
      || props.orders !== nextProps.orders
      ||  !_.isEqual(props.driversLocations, nextProps.driversLocations)
      || props.allPickUpPoints !== nextProps.allPickUpPoints
      || props.setOfLocationsToShowPopup !== nextProps.setOfLocationsToShowPopup
      || props.setOfDriverLocationIdsToShowPopup !== nextProps.setOfDriverLocationIdsToShowPopup
      || props.company !== nextProps.company
      || props.recipients !== nextProps.recipients
      || props.polygon !== nextProps.polygon
      || props.selectedDriver !== nextProps.selectedDriver
      || props.nearestDrivers !== nextProps.nearestDrivers
      || props.nearestCenter !== nextProps.nearestCenter
      || (props.showOrderOption)
      || ((props.defaultZoom) && (props.defaultZoom !== nextProps.defaultZoom))
      || props.showModal !== nextProps.showModal;
  }
  renderInfoWindow(ref, marker) {
    const { dashboardType } = this.state;
    let renderedPages;
    if(dashboardType == "onDemand") {
      renderedPages = _.map(marker.orders, ({ order, markerType, item }, index) => {
        const address = marker.address;
        return (
          <Carousel.Item key={`carousel_item_${order.id}_${index}`}>
            <a href="#" onClick={() => this.props.renderModalForDetails(order)} style={{color: '#6b0b69'}}>
              <strong style={{fontSize: 16 }}>{address}</strong>
              <br />
              {(order.recipient && order.recipient.firstName)?'':gettext('CREATED-BY')+ ':'} <strong>{`${(order.recipient && order.recipient.firstName) ? order.recipient.firstName : (order.createdBy ? order.createdBy.companyName : '')}`}</strong>              
            </a>
          </Carousel.Item>
        );
      });
    } else {
      renderedPages = _.map(marker.orders, ({ order, markerType, item }, index) => {
        const address = marker.address;
        const packingList = (item && item.packingList) ? (
          <span><strong>{item.packingList}</strong><br /></span>
        ) : null;
        const itemCount = order.items ? order.items.length : '0';
        return (
          <Carousel.Item key={`carousel_item_${order.id}_${index}`}>
            {/*<Checkbox
              checked={true}
              onChange={(e) => this.props.handleOrderSelectChange(order, e)}
            >{gettext('ORDER.SELECT-ORDER')}</Checkbox>*/}
            <a href="#" onClick={() => this.props.renderModalForDetails(order)}>
              <strong>{formatCamelCase(markerType)}</strong>
              <br />
              {packingList}
              <strong>{gettext('ORDER-#')} {formatId(order.id)}</strong>
              <br />
              <strong>{getStatus(order.orderStatus)}</strong>
              <strong>{` ${itemCount} ${gettext('ITEM.ITEMS')}`}</strong>
              <br />
              {gettext('PICKUP-TIME')}: <strong>{parseExpectedPickUpTime(order.expectedPickUpTime)}</strong>
              <br />
              {gettext('CREATED-BY')}: <strong>{`${order.createdBy ? order.createdBy.companyName : ''}`}</strong>
              <br />
              {address}
            </a>
          </Carousel.Item>
        );
      });
    }

    return (
      <InfoWindow
        key={`${ref}_info_window`}
        onCloseclick={() => this.props.handleMarkerClose(JSON.stringify(marker.position))}
      >
        <Carousel interval={0} direction={null} indicators={true}
          className="mapPopupCarousel">
          {renderedPages}
        </Carousel>
      </InfoWindow>
    );
  }

  showNearestDrivers(e) {
    this.props.getNearestDrivers(e, e);
    if(this.props.setNearestCenter)
      this.props.setNearestCenter(e);
  }
  renderDriverInfoWindow(ref, driverLocation) {
    const driver = _.find(this.props.drivers, { id: driverLocation.driverId });
    const driverForWindow = driver ? driver : gettext('CANNOT-GET-DRIVER');
    return (
      <InfoWindow key={`${ref}_driver_info_window`}
        onCloseclick={() => this.props.handleDriverMarkerClose(driverLocation.id)}>
        <div>{driverForWindow.firstName}</div>
      </InfoWindow>
    );
  }

  changeMapStyle(style) {
    localStorage.setItem('map_style', style);
    this.setState({});
    // window.location.reload();
  }

  render() {
    let { showOrderOption } = this.props;
    if(!this.props.orders)
      return null;

    let ordersForMap =  _.filter(this.props.orders, (order) => mapStatuses[order.orderStatus]);
    this.selectedDriver = this.props.selectedDriver;
    var driversLocations = this.selectedDriver
      ? _.filter(this.props.driversLocations, { driverId: this.selectedDriver.id })
      : this.props.driversLocations;
    if (driversLocations.length == 0) {
      this.selectedDriver = undefined;
      driversLocations = this.props.driversLocations;
    }
  
    let markers = buildMapMarkersList(
      ordersForMap,
      this.props.recipients,
      this.props.allPickUpPoints,
      showOrderOption
    );

    if (this.props.polygon) {
      showTeam(markers, this.props.polygon, this._map);
    }

    let nearestDriversPosition=[];
    this.props.nearestDrivers.map((nearestDriver) => {
      nearestDriversPosition.push(nearestDriver.driverGpsLocations.gpsLocation);
    });
    return (
      <div style={{position:'relative'}}>
        <MarkerCategoryModal
          upCategoryIndex={this.props.upCategoryIndex}
          fullSize={this.props.fullSize}
          showModal={this.props.showModal}
          changeCategoryState={this.props.changeCategoryState} />
        <GettingStartedGoogleMap
          containerElement={
            <div
              dir={getCurLang() === 'ar' ? 'rtl' : 'ltr'}
              className="mapContainer" />
          }
          mapElement={
            <div style={{ height: this.props.fullSize ? 'calc(100vh - 50px)' : '100%' }} />
          }
          updateUpCategoryIndex={this.props.updateUpCategoryIndex}
          setDefaultCenterAndZoom={this.setDefaultCenterAndZoom}
          nearestCenter={this.props.nearestCenter}
          renderModalForDetails={this.props.renderModalForDetails}
          nearestDriversPosition={nearestDriversPosition}
          nearestDrivers={this.props.nearestDrivers}
          showOrderOption={this.props.showOrderOption}
          changeCategoryState={this.props.changeCategoryState}
          driverShowType={this.props.driverShowType}
          onMapClick={this.props.closeAllInfoWindows}
          fullSize={this.props.fullSize}
          driversLocations={driversLocations}
          setOfDriverLocationIdsToShowPopup={this.props.setOfDriverLocationIdsToShowPopup}
          renderDriverInfoWindow={this.renderDriverInfoWindow}
          onDriverMarkerClick={this.props.onDriverMarkerClick}
          users={this.props.users}
          drivers={this.props.drivers}
          defaultZoom={this.props.defaultZoom}
          toggleCategoryModal={this.props.toggleCategoryModal}
          showModal={this.props.showModal}
          onMarkerClick={(e)=>{this.props.onMarkerClick(e);this.showNearestDrivers(e);}}
          setOfLocationsToShowPopup={this.props.setOfLocationsToShowPopup}
          renderInfoWindow={this.renderInfoWindow}
          dashboardType={this.state.dashboardType}
          markers={_.filter(markers, (marker) => {
            return !marker.hide;
          })}
          onMapMounted={this.handleMapMounted}
          polygon={this.props.polygon}
          clearSelectedOrders={this.props.clearSelectedOrders}/>
      </div>
    );
  }
}

OrdersMap.propTypes = {
  defaultZoom: PropTypes.number,
  onMapClick: PropTypes.func,
  allPickUpPoints: PropTypes.object,
  onMarkerClick: PropTypes.func,
  onDriverMarkerClick: PropTypes.func,
  onMarkerRightClick: PropTypes.func,
  handleMarkerClose: PropTypes.func,
  handleDriverMarkerClose: PropTypes.func,
  handleOrderSelectChange: PropTypes.func.isRequired,
  onOrderDetailLinkClick: PropTypes.func,
  driversLocations: PropTypes.array,
  recipients: PropTypes.array,
  users: PropTypes.array,
  setOfLocationsToShowPopup: PropTypes.instanceOf(Set),
  setOfDriverLocationIdsToShowPopup: PropTypes.instanceOf(Set)
};

function mapStateToProps(state) {
  return {
    drivers: state.dashboardPageReducer.drivers,
    driversLocations: state.dashboardPageReducer.driversLocations
  };
}

function mapDispatchToProps(dispatch) {
  return {

  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OrdersMap);



// WEBPACK FOOTER //
// ./src/components/maps/OrdersMap.js